"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SharepointMulticolorFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__sharepoint-multicolor-filled__clip0_13467_150)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#016C70",
    d: "M8.19 9.12a4.47 4.47 0 100-8.94 4.47 4.47 0 000 8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#189A9F",
    d: "M11.91 12.83a4.09 4.09 0 100-8.18 4.09 4.09 0 000 8.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41C1CC",
    d: "M8.74 15.81a3.16 3.16 0 100-6.32 3.16 3.16 0 000 6.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.93 4.22v7.94a.7.7 0 01-.42.63.805.805 0 01-.26.05H5.59a1.28 1.28 0 010-.19 1.088 1.088 0 010-.18 3.18 3.18 0 011.89-2.72v-.69A4.45 4.45 0 013.78 4c0-.13.05-.25.08-.38h4.39a.7.7 0 01.68.6z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.88 3.91h-4.1a4.45 4.45 0 003.65 5.14h.22a4.27 4.27 0 00-2.06 3.39c-.005.06-.005.12 0 .18v.56h2.29a.7.7 0 00.63-.42.8.8 0 00.05-.26V4.59a.68.68 0 00-.68-.68z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.88 3.91h-4.1a4.45 4.45 0 003.65 5.14h.15a4.38 4.38 0 00-2 3.39h2.3a.7.7 0 00.68-.69V4.59a.68.68 0 00-.68-.68z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.51 3.91H3.78A4.46 4.46 0 007.08 9a6.14 6.14 0 00-1.49 3.49h1.92a.7.7 0 00.68-.69V4.59a.68.68 0 00-.68-.68z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__sharepoint-multicolor-filled__paint0_linear_13467_150)",
    d: "M.68 3.91H7.5a.68.68 0 01.69.68v6.82a.68.68 0 01-.69.68H.68a.68.68 0 01-.68-.68V4.59a.68.68 0 01.68-.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.05 7.92a1.21 1.21 0 01-.39-.42 1.08 1.08 0 01-.14-.56 1.06 1.06 0 01.25-.73 1.48 1.48 0 01.67-.44c.296-.1.607-.148.92-.14.41-.019.82.039 1.21.17v.85A2.11 2.11 0 005 6.43a2.8 2.8 0 00-.64-.08 1.35 1.35 0 00-.66.14.44.44 0 00-.26.4.43.43 0 00.11.28.9.9 0 00.3.21l.55.25h.08c.26.097.507.22.74.37.17.1.31.24.41.41.108.195.16.417.15.64a1.16 1.16 0 01-.23.76c-.167.2-.39.347-.64.42-.29.097-.594.144-.9.14a5.688 5.688 0 01-.82-.07 2.64 2.64 0 01-.66-.2v-.9c.202.146.43.255.67.32.239.08.488.12.74.12.231.009.461-.04.67-.14a.47.47 0 00.23-.4.44.44 0 00-.13-.31 1.21 1.21 0 00-.35-.24 9.152 9.152 0 00-.66-.3 3.64 3.64 0 01-.65-.33z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__sharepoint-multicolor-filled__paint0_linear_13467_150",
    x1: 1.42,
    x2: 6.76,
    y1: 3.37,
    y2: 12.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006D71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__sharepoint-multicolor-filled__clip0_13467_150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SharepointMulticolorFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SharepointMulticolorFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SharepointMulticolorFilled;
exports["default"] = _default;